import EmptyComponent from './commonEmpty'
export default {
    install: (Vue) => {
        Vue.component('commonEmpty',EmptyComponent)
    }
}